import { useParams } from "react-router";
import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { AuditGroupChartDataViewModel } from "@common/components/managementReport/managementReportCharts/allocationOfRiskLevelChart/AllocationOfRiskLevelChart.types";
import { InternalAssessmentGroupOverviewModel } from "../InternalAssessmentGroups.types";

export default function useInternalAssessmentGroupManagementReport() {
    const { id } = useParams<{ id: string }>();

    const urlParams = new URLSearchParams(window.location.search);
    const isPdf = Boolean(urlParams.get("isPdf"));

    const { isLoading, data } = useDotLegalQuery<InternalAssessmentGroupOverviewModel>(`/internalAssessmentGroups/${id}/overview`);

    const chartDataQuery = useDotLegalQuery<AuditGroupChartDataViewModel>(`/internalAssessmentGroups/${id}/chartData`, {
        enabled: data !== undefined && data.scoreEnabled,
    });

    return {
        isLoading: isLoading || chartDataQuery.isLoading,
        data,
        isPdf,
        chartData: chartDataQuery.data,
    };
}
